/* =====================================================================
 * settingsModalSlot — DI slot for the tenant-specific Settings modal.
 *
 * `ChatArea` surfaces a "Settings" gear button that opens the user's
 * account/settings panel, and `WorkspaceShell` renders the modal at the
 * workspace root so it can be reached from anywhere (settings store
 * events, deep links, etc.).  Because the panel itself (cookie consent,
 * legal versions, provider-specific toggles, ...) is host-specific
 * (B2C ships the full GDPR cookie flow, on-prem tenants ship a
 * stripped down corporate settings), we expose the actual component
 * via a DI slot.  Hosts register their implementation during bootstrap;
 * consumers read it at render time and render nothing when no component
 * is registered (the gear button silently no-ops, which is the correct
 * behaviour for hosts that do not ship a settings panel).
 *
 * The props surface intentionally mirrors the B2C SettingsModal — hosts
 * that do not use `initialTab` / `focusSection` / `requestId` can ignore
 * them (they are optional).
 * ===================================================================== */

import type React from 'react';
import type { SettingsTab } from '@auw/stores';

export interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  initialTab?: SettingsTab;
  focusSection?: string;
  requestId?: number;
}

export type SettingsModalComponent = React.ComponentType<SettingsModalProps>;

let _impl: SettingsModalComponent | null = null;

export function setSettingsModalComponent(comp: SettingsModalComponent | null): void {
  _impl = comp;
}

export function getSettingsModalComponent(): SettingsModalComponent | null {
  return _impl;
}
